import { type ReactNode } from 'react';

/**
 * SectionCard — обёртка секции калькулятора per прототип `cardS` pattern.
 *
 * Прототип 2.12.2 line 42 (cardS const):
 *   `background: '#fff', border: '1.5px solid OR (#ff9156)', borderRadius: 16,
 *    boxShadow: '0 2px 6px rgba(60,30,10,.08)', padding: 16, marginBottom: 14`
 * Прототип 2.12.2 lines 351, 376, 449, 492, 501, 510, 527 (применение cardS со всеми sections).
 *
 * Tailwind mapping (design-system.md v0.3):
 * - bg-card        → #ffffff
 * - border-accent  → #ff9156 (OR)
 * - shadow-card    → 0 2px 6px rgba(60,30,10,0.08) (exact match)
 * - rounded-2xl    → 16px
 * - p-4            → 16px padding
 * - mx-3           → 12px margin-x
 *
 * **Vertical spacing** между sections — ответственность layout-родителя
 * (AnketaFormView использует `flex flex-col gap-6`). В прототипе sections
 * получают `margin: '0 12px'` (overrides cardS.marginBottom 14 → 0), потому что
 * визуальный ритм управляется AnketaFormView gap'ом. Бэйкать `mb-3.5` в
 * primitive нельзя — дублирует gap родителя (Phase A1 review 2026-05-16 MEDIUM).
 */
export interface SectionCardProps {
  children: ReactNode;
  className?: string;
  /** Test id для query в тестах. */
  testId?: string;
}

export function SectionCard({ children, className = '', testId }: SectionCardProps) {
  return (
    <section
      data-testid={testId}
      className={`bg-card border-[1.5px] border-accent rounded-2xl shadow-card p-4 mx-3 ${className}`.trim()}
    >
      {children}
    </section>
  );
}
